export enum SponsorRelations {
  trail = 'trail',
  system = 'system',
}
